export * from './lib/pois-pois-table.module';
export { PoisTableComponent } from './lib/pois-table/pois-table.component';
export { PoisSearcherService } from './lib/pois-searcher.service';
